// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"data-board_wrapper__1GC77"};